export default "__VITE_ASSET__QBwKbA67__"